import { cloneDeep, get } from 'lodash';
import { merge, isNull, findAllIndexes, isArr } from '../../../editor/core/highcharts-editor';
import { updateDataLabelAction } from '../../../pages/ChartEditorPage/actions/chartEditor';
import { getSeries } from './WidgetHelper';

const getDecimalValue = (value) => {
  let decRegex = /\.([0-9])/;
  const regex = /{.*?}/g;
  const found = value ?? ''.match(regex);
  if (!found.length) return 0;
  const splitValue = found.split(':');
  if (splitValue.length <= 1) return 0;
  const dec = splitValue[1].match(decRegex);
  if (dec && dec.length) return parseInt(dec[1], 10);
  return 0;
};

export const extractDataLabelOptions = (aggregatedOptions, group, detailIndex) => {
  let chart = aggregatedOptions; // highchart || {};
  // if (chart.userOptions) chart = chart.userOptions;

  const types = (chart.series || []).map((series) => series.type || (chart.chart && chart.chart.type) || 'line');
  const uniqueTypes = [...new Set(types)];

  // Highcharts has 3 different places where a data label can be added. The priority for these are:
  // 1. Each Series Options -> dataLabels
  // 2. Plot Options -> Template Type (ex: Line) -> dataLabels
  // 3. Plot Options -> Series -> dataLabels

  const seriesDataLabelProp = get(chart, 'plotOptions.series.dataLabels');
  let allSeriesDataLabelProp = chart.series.map(() => cloneDeep(seriesDataLabelProp || {}));

  uniqueTypes.forEach((type) => {
    const typeDataLabel = get(chart, `plotOptions.${type}.dataLabels`);
    const indexes = findAllIndexes(types, type);
    indexes.forEach((index) => {
      allSeriesDataLabelProp[index] = merge(cloneDeep(allSeriesDataLabelProp[index]), typeDataLabel);
    });
  });

  chart.series.forEach((series, i) => {
    const dataLabel = (isArr(series.dataLabels) ? series.dataLabels[0] : series.dataLabels) || {};
    allSeriesDataLabelProp[i] = merge(cloneDeep(allSeriesDataLabelProp[i]), dataLabel);
  });

  allSeriesDataLabelProp.forEach((series) => {
    series.decimalValue = getDecimalValue(series.format ?? '');
  });

  if (detailIndex === 'all') {
    // All Series
    let isEqual = false;
    if (!isNull(get(allSeriesDataLabelProp[0], group.rawKey))) {
      isEqual = allSeriesDataLabelProp.every((prop) => {
        return get(allSeriesDataLabelProp[0], group.rawKey) === get(prop, group.rawKey);
      });
    }
    if (isEqual) return get(allSeriesDataLabelProp[0], group.rawKey) ?? group.default;
    return group.default;
  }

  // Individual series
  const opt = get(allSeriesDataLabelProp[detailIndex], group.rawKey) ?? group.default;
  if (!isNull(opt)) {
    return get(allSeriesDataLabelProp[detailIndex], group.rawKey) ?? group.default;
  }
};

export default ({ dispatch, props }) => {
  const changeDataLabelValue = (option, value, detailIndex) => {
    /**
     * Change All Series
     * 1. Delete all series -> dataLabel option
     * 2. Delete all plotOption -> Type -> dataLabel option
     * 3. Change value of plotOption -> Series
     *
     * Change Individual Series
     * 1. Change value of series -> dataLabel option
     */
    dispatch(
      updateDataLabelAction({
        option,
        value,
        detailIndex
      })
    );
    /*
    if (detailIndex === 'all') {
      if (group.dataType === 'font') {
        chartPreview.deleteDataLabelOptions(group.rawKey + '.' + optionDetails);
      } else chartPreview.deleteDataLabelOptions(group.rawKey);
    }*/
  };

  return ({ detailIndex, onOptionChange }) => {
    const { option, aggregatedOptions, userAggregatedOptions, chart } = props;
    let selectOptions = getSeries(option, aggregatedOptions, chart) || [];
    return {
      selectOptions,
      selectValue: selectOptions.find((d) => d.value === detailIndex),
      onChangeSelect: onOptionChange,
      filteredOptions: option,
      extractValue: (property) => extractDataLabelOptions(userAggregatedOptions, property, detailIndex),
      onChangeValue: (type, option, val) => changeDataLabelValue(option, val, detailIndex)
    };
  };
};
